<template>
  <modal :id="itemStatusModalId">
    <div class="add-user">
      <b-row>
        <b-col>
          <h3>
            <strong>Add Provider </strong>
            <close-button
                class="float-right"
                @close-button-click="handleCloseBtnClick"
            />
          </h3>
        </b-col>
      </b-row>
      <b-row style="margin-top: 25px">
        <b-col>
          <b-img
            v-if="formProvider && formProvider.imgURL"
            :src="formProvider.imgURL"
            fluid
            style="object-fit: contain"
            :alt="`Logo`"
          />
          <image-upload
            v-else
            ref="image-upload"
            class="photo-upload-wrapper"
            :img-upload-idx="idx"
            img-upload-type="photo"
            :storage-path="storagePath"
            :max-image="1"
            :show-edit="false"
            :show-delete="true"
            text-drag="Upload Provide Log. "
            @img-uploaded-url="handleLogoUploadedURL"
          />
        </b-col>
        <b-col>
          <!-- NAME -->
          <b-form-group>
            <label-info
              v-if="false"
              id="form-name"
              label-name="Provider Name"
              label-info=""
            />
            <b-form-input
              v-model="formProvider.name"
              type="text"
              class="custom-input"
              style="
                    border-radius:50px;
                    padding:20px;"
              placeholder="Provider Name"
            />
          </b-form-group>
          <!-- PROFILE Name -->
          <b-form-group>
            <label-info
                v-if="false"
                id="form-name"
                label-name="AAA"
                label-info=""
            />
            <b-form-input
                v-model="formProvider.profileName"
                type="text"
                class="custom-input"
                style="
                    border-radius:50px;
                    padding:20px;"
                placeholder="Profile Name"
            />
          </b-form-group>
          <!-- URL -->
          <b-form-group>
            <label-info
              v-if="false"
              id="form-name"
              label-name="Provider URL"
              label-info=""
            />
            <b-form-input
              v-model="formProvider.url"
              type="text"
              class="custom-input"
              style="
                    border-radius:50px;
                    padding:20px;"
              placeholder="Provider URL"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <!-- DESCRIPTION (OPT)-->
          <b-form-group
              id="input-group-1"
              label="Description:"
              label-for="input-description"
              style="margin-top: 25px;"
              description="Copy and Paste"
          >
            <transition name="fadeHeight" mode="out-in">
              <editor
                  id="textarea-default"
                  v-show="formProvider"
                  @input="input"
                  :clear="clear"
                  :content="formProvider.description"
                  @resetClear="resetClear"
              />
            </transition>
          </b-form-group>
          <span class="error">
            <div v-for="(anError, i) in this.errors" :key="`err_${i}`">
              {{ anError }}
            </div>
          </span>
          <b-form-group>
            <b-button
                v-if="this.providerData && this.isUpdate"
                pill
                class="btn btn-success float-right"
                style="border: none; background-color: #d4ad49; padding: 10px;"
                @click="handleUpdateProviderClick"
            >
              Update
              {{ formProvider && formProvider.name ? formProvider.name : "your Provider" }}
            </b-button>
            <b-button
                v-else
                pill
                class="btn btn-success float-right"
                style="border: none; background-color: #fe818b; padding: 10px;"
                @click="handleAddProviderClick"
            >
              Add {{ formProvider && formProvider.name ? formProvider.name : " Provider" }}
            </b-button>
          </b-form-group>
        </b-col>
      </b-row>
    </div>
  </modal>
</template>

<script>
import Modal from "@/components/common/modal";
import CloseButton from "@/components/common/closeButton";
import UploadImage from "@/mixins/UploadImage";
import VideoHandling from "@/mixins/VideoHandling";
import ImageUpload from "@/components/common/imageUpload";
import Editor from "@/components/common/editor";
import axios from "axios";
export default {
  name: "Admin_Manage_AddEditItem_Providers",
  mixins: [UploadImage, VideoHandling],
  components: {
    Modal,
    CloseButton,
    ImageUpload,
    Editor
  },
  props: {
    profile: {
      type: Object,
      default: () => {}
    },
    itemStatusModalId: {
      type: String,
      default: "add-edit-item-status"
    }
  },
  computed: {
    formData() {
      return this.entity && this.entity.form ? this.entity.form : null;
    }
  },
  created() {
    this.formReset();
  },
  mounted() {},
  methods: {
    handleAddItem() {
      this.isUpdate = false;
      this.$bvModal.show(this.itemStatusModalId);
    },
    handleUpdateItem(providerData) {
      this.isUpdate = true;
      this.providerData = providerData;
      this.formProvider = providerData && providerData.form ? _.clone(providerData.form) : {};
      this.$bvModal.show(this.itemStatusModalId);
    },
    handleCloseBtnClick() {
      this.entity = null;
      this.$bvModal.hide(this.itemStatusModalId);
    },
    handleLogoUploadedURL(idx, url) {
      this.formProvider.imgURL = url;
    },
    handleAddProviderClick() {
      if (this.simpleValidate().length > 0) return;

      axios.get("https://api.ipify.org?format=json").then(res => {
        let ip = res.data.ip;
        this.$store
          .dispatch("admin/addProvider", {
            info: this.formProvider,
            ip
          })
          .then(res => {
            this.$emit("item-added");
            this.handleCloseBtnClick();
            this.formReset();
          });
      });
    },
    handleUpdateProviderClick() {
      if (this.simpleValidate().length > 0) return;

      axios.get("https://api.ipify.org?format=json").then(res => {
        let ip = res.data.ip;
        this.$store
          .dispatch("admin/updateProvider", {
            id: this.providerData && this.providerData.id ? this.providerData.id : null,
            info: this.formProvider,
            ip
          })
          .then(res => {
            this.$emit("item-added");
            this.handleCloseBtnClick();
            this.formReset();
          });
      });
    },
    simpleValidate() {
      this.errors = [];

      /* if (this.formProvider && !this.validateEmail(this.formProvider.email))
         this.errors.push("Please enter a valid email");*/

      if (
        (this.formProvider && !this.formProvider.name) ||
        this.formProvider.name.length === 0
      )
        this.errors.push("Please enter fave name");

      if (
        (this.formProvider && !this.formProvider.url) ||
        this.formProvider.url.length === 0
      )
        this.errors.push("URL is required");

      return this.errors;
    },
    validateEmail(email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    formReset() {
      this.formProvider = null;
      this.formProvider = this.formDefault;
    },
    handleSubmitANewMemory() {
      this.formReset();
      this.memorySubmitted = false;
    },
    input(val) {
      this.formProvider.description = val.content;
    },
    resetClear() {
      this.clear = false;
    }
  },
  data() {
    return {
      clear: false,
      idx: 0,
      storagePath: "providers_logos_imgs",
      isUpdate: false,
      providerData: null,
      formProvider: null,
      formDefault: {
        name: null,
        profileName: null,
        description: [],
        url: null,
        imgURL: null
      },
      errors: [],
      entity: null
    };
  }
};
</script>

<style lang="scss" scoped>
.status-box {
  background-color: #a9a6a6;
  border-radius: 15px;
  padding: 10px;
  margin: 15px;
}
</style>
